var map = {
	"./br/PT/S1/bg67.png": 56286,
	"./br/PT/bg67.png": 99334,
	"./in/EN/S1/bg67.png": 95161,
	"./ph/EN/S1/bg67.png": 61164,
	"./ph/EN/bg67.png": 46643,
	"./vn/VI/S1/bg67.png": 42560
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83246;